<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top v-if="toolbar">
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.started="{item}">
        {{ formatDate(item.started) }}
      </template>

      <template v-slot:item.default="{item}">
        <v-icon color="green" v-if="item.default">mdi-check-circle</v-icon>
      </template>
      <template v-if="!readonly" v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-smart-offer-skin-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import { SmartOfferSkin } from "@/modules/redactor/models/smart-offer/core/SmartOfferSkin";
import RSmartOfferSkinDialog from "@/modules/redactor/views/smart-offer/reskin/r-smart-offer-skin-dialog";
import moment from "moment";

export default {
  name: "r-smart-offer-skin-table",
  components: {RSmartOfferSkinDialog},
  props: {
    title: VueTypes.string.isRequired,
    items: VueTypes.arrayOf(SmartOfferSkin).isRequired,
    toolbar: VueTypes.bool.def(true),
    readonly: VueTypes.bool.def(false)
  },
  data: () => ({
    headers: [
      {text: 'Key', value: 'key'},
      {text: 'Start Time (UTC +0)', value: 'started'},
      {text: 'Duration', value: 'duration'},
      {text: 'Default', value: 'default'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    }
  },
  methods: {
    formatDate(timestamp) {
      return moment.unix(parseInt(timestamp)).utc().format("DD/MM/YYYY HH:mm");
    },

    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            if(this.items.length == 0){
              data.default = true;
            }

            if(this.items.find((item) => item.key == data.key)){
              this.$alert("Dublica of skin key !");
              return;
            }

            const anyIntervalsIntersect = (intervals) =>
                intervals
                .sort((a, b) => a[0] - b[0])
                .some((_, i, arr) => i > 0 && arr[i - 1][1] >= arr[i][0]);

            const buildTimeIntervals = (skins) => {
                let timeIntervals = []
                skins.forEach(function(skin) {
                    timeIntervals.push([skin.started, skin.started + skin.duration]);
                });
                return timeIntervals;
            }

            let skins = this.items.slice();
            skins.push(data);
            
            if(anyIntervalsIntersect(buildTimeIntervals(skins))){
              this.$alert("Overlap of skin time intervals !");
              return;
            }

            if(data.default){
              this.items.forEach(item => {
                item.default = (item.key == data.key);
              });
            }
            if(data.default){
              this.items.forEach(item => {
                item.default = (item.key == data.key);
              });
            }
            const existDefault = this.items.some((item) => item.default);  
            if(!existDefault){
              data.default = true;
            }
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            
            let skins = this.items.slice();
            const idx = this.items.indexOf(item); 
            skins.splice(idx, 1, data);

            if(skins.filter((skin) => skin.key == data.key).length != 1){
              this.$alert("Duplicate of skin key !");
              return;
            }
            
            if(skins.some(skin => !skin.default && skin.duration == 0)){
              this.$alert("Invalid duration for skin !");
              return;
            }

            const anyIntervalsIntersect = (intervals) =>
                intervals
                .sort((a, b) => a[0] - b[0])
                .some((_, i, arr) => i > 0 && arr[i - 1][1] >= arr[i][0]);

            const buildTimeIntervals = (skins) => {
                let timeIntervals = []
                skins.forEach(function(skin) {
                    timeIntervals.push([skin.started, skin.started + skin.duration]);
                });
                return timeIntervals;
            }
            
            if(anyIntervalsIntersect(buildTimeIntervals(skins))){
              this.$alert("Overlap of skin time intervals !");
              return;
            }

            const index = this.items.indexOf(item); 
            this.items.splice(index, 1, data);

            if(data.default){
              this.items.forEach(item => {
                item.default = (item.key == data.key);
              });
            }
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this reskin?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
        if(item.default && this.items.length > 0){
          this.items[0].default = true;
        }
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    }
  }
}
</script>